import { Component, inject, Injectable } from "@angular/core";

@Component({
  standalone: false,
  selector: 'app-pagecustom',
  template: `<h1>Sample Custom Angular Module</h1>`
})
export class PageCustomComponent{}